import './ErrorAlert.scss';

import { mdiReplay } from '@mdi/js';
import { Alert } from 'antd';
import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface Props {
  errorCode: string;
  onRetry?: () => void;
  type?: 'success' | 'info' | 'warning' | 'error';
  newTranslate?: boolean;
}

const ErrorAlert: React.FC<Props> = (props): React.ReactElement => {
  const { t, tError } = useCustomTranslation();

  return (
    <Alert
      className="ErrorAlert"
      message={props.newTranslate ? tError(props.errorCode) : t(props.errorCode)}
      type={props.type || 'error'}
      action={
        props.onRetry && (
          <Button className="ml-1" onClick={props.onRetry} icon={<Icon path={mdiReplay} />}>
            {t('common.retry')}
          </Button>
        )
      }
    />
  );
};

export default ErrorAlert;
